import { lazy } from 'react';

const NotFound = lazy(() => import('./scenes/NotFound/NotFound'));
const CookieNotice = lazy(() => import('./scenes/CookieNotice'));
const Transport = lazy(() => import('./scenes/Transport/Transport'));

const routes = [
  {
    name: 'main',
    path: '/',
    exact: true,
    component: Transport,
  },
  {
    name: 'transport',
    path: '/transport',
    exact: true,
    component: Transport,
  },
  {
    name: 'not-found',
    path: '/not-found',
    component: NotFound,
  },
  {
    name: 'cookie-notice',
    path: '/cookie-notice',
    component: CookieNotice,
  },
];

export { routes };
